import { createAsyncThunk } from "@reduxjs/toolkit";
import client from "../../../app/core/client-http/client";

export const createAssistenza = createAsyncThunk(
  "creaAssistenza/create",
  async (assistenzaData) => {
    const endpoint = "admin/account/contactus";
    const response = await client.post(endpoint, assistenzaData);
    return response.data;
  }
);
